import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import DropdownProfile from './DropdownProfile';
import { Config } from '../../config';
import { useLabels } from '../../providers/LabelsProvider';
import { useI18n, useT } from '../../providers/I18nProvider';
import { authApi } from '../../services/api';

export default function Header({ onHamburgerClick }) {
  const labels = useLabels();
  const t = useT();
  const { locale, setLocale } = useI18n();

  const handleLanguageChange = (lang) => {
    setLocale(lang);
    authApi.updateLanguage(lang).catch(() => {});
  };
  const location = useLocation();
  const role = localStorage.getItem('role') || 'user';
  const isAdmin = role === 'global_admin' || role === 'assessment_admin' || role === 'admin';

  const isActive = (path) => {
    return location.pathname === path || (path !== '/dashboard' && location.pathname.startsWith(path));
  };

  return (
    <header className="sticky pt-2 pb-2 top-0 bg-white border-b border-slate-200 z-30 shadow-sm">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center space-x-4">
            {/* Hamburger Button */}
            <button
              onClick={onHamburgerClick}
              className="md:hidden p-2 hover:bg-eucnet-grey-100 rounded-lg transition-colors"
              title={t('nav.toggleMenu')}
            >
              <svg className="w-6 h-6 text-eucnet-grey-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>

            {/* Logo */}
            <Link to="/dashboard" className="flex items-center space-x-3">
              <img 
                src={labels.navbarLogo || Config.navbarLogo}
                alt="Logo" 
                className="h-[83px] w-auto"
              />
              <div className="hidden sm:block">
                <h1 className="text-xl font-bold text-eucnet-navy">{labels.headerTitle}</h1>
                <p className="text-xs text-eucnet-grey-600">{labels.headerSubtitle}</p>
              </div>
            </Link>
          </div>

          {/* Right side */}
          <div className="flex items-center space-x-4">

            {/* Navigation: main options; management lives under Admin */}
            <nav className="hidden md:flex items-center space-x-6 text-sm font-medium">
              <Link to="/dashboard" className="text-eucnet-grey-700 hover:text-eucnet-blue transition-colors">
                {t('nav.dashboard')}
              </Link>
              {isAdmin && (
                <>
                  <Link to="/admin/assessment-results" className="text-eucnet-grey-700 hover:text-eucnet-blue transition-colors">
                    {t('nav.assessments')}
                  </Link>
                  <Link to="/admin/reports" className="text-eucnet-grey-700 hover:text-eucnet-blue transition-colors">
                    {t('nav.reports')}
                  </Link>
                  <Link to="/admin" className="text-eucnet-grey-700 hover:text-eucnet-blue transition-colors">
                    {t('nav.admin')}
                  </Link>
                </>
              )}
            </nav>
            {/* Notifications placeholder */}
            <button
              className="w-9 h-9 flex items-center justify-center bg-eucnet-grey-100 hover:bg-eucnet-grey-200 rounded-full transition-colors"
              title={t('nav.notifications')}
            >
              <svg className="w-5 h-5 text-eucnet-grey-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
              </svg>
            </button>

            {/* Divider */}
            {/* Language Toggle */}
            <div className="flex items-center bg-eucnet-grey-100 rounded-lg text-[11px] font-medium overflow-hidden">
              <button
                onClick={() => handleLanguageChange('en')}
                className={`px-2 py-1.5 transition-colors ${locale === 'en' ? 'bg-eucnet-blue text-white' : 'text-eucnet-grey-600 hover:bg-eucnet-grey-200'}`}
              >
                EN
              </button>
              <button
                onClick={() => handleLanguageChange('es')}
                className={`px-2 py-1.5 transition-colors ${locale === 'es' ? 'bg-eucnet-blue text-white' : 'text-eucnet-grey-600 hover:bg-eucnet-grey-200'}`}
              >
                ES
              </button>
            </div>

            <div className="h-6 w-px bg-eucnet-grey-300"></div>

            {/* Profile Dropdown */}
            <DropdownProfile />
          </div>
        </div>
      </div>
    </header>
  );
}
